import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useQueryClient} from 'react-query';
import {get} from 'lodash';
import {isNewPasswordValid} from '../../../utils/validateNewPassword';
import Form from '../../../containers/form/form';
import Field from '../../../containers/form/field';
import Button from '../../../components/ui/button';
import {usePostQuery} from '../../../hooks/api';
import {URLS} from '../../../constants/url';
import {KEYS} from '../../../constants/key';
import {OverlayLoader} from '../../../components/loader';
import {useTranslation} from 'react-i18next';
import Swal from 'sweetalert2';
import i18next from 'i18next';

const PasswordChangeContainer = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const {mutate, isLoading} = usePostQuery({hideSuccessToast: true});

    const passwordRequest = ({data, setError}) => {
        const newPassword = get(data, 'newPassword');
        if (!isNewPasswordValid(newPassword)) {
            setError('newPassword', {type: 'manual', message: t('Password policy error')});
            return;
        }
        if (newPassword !== get(data, 'confirmPassword')) {
            setError('confirmPassword', {type: 'manual', message: t('Password mismatch')});
            return;
        }
        mutate(
            {
                url: URLS.changePassword,
                attributes: {
                    oldPassword: data.oldPassword,
                    newPassword: data.newPassword,
                },
            },
            {
                onSuccess: async () => {
                    await queryClient.refetchQueries({
                        predicate: (q) => q.queryKey[0] === KEYS.getMe,
                    });
                    i18next.reloadResources();
                    Swal.fire({
                        position: 'center',
                        icon: 'success',
                        backdrop: 'rgba(0,0,0,0.9)',
                        background: 'none',
                        title: t('Password updated'),
                        showConfirmButton: false,
                        timer: 1600,
                        customClass: {title: 'title-color'},
                    });
                    navigate('/products/all', {replace: true});
                },
            }
        );
    };

    if (isLoading) {
        return <OverlayLoader/>;
    }

    return (
        <div>
            <Form formRequest={passwordRequest} footer={<Button className={'form-btn'} type={'submit'}>{t('Change password')}</Button>}>
                <Field
                    name={'oldPassword'}
                    type={'input'}
                    label={t('Current password')}
                    params={{required: true}}
                    property={{
                        type: 'password',
                        placeholder: t('Current password'),
                        showPasswordToggle: true,
                        autoComplete: 'current-password',
                    }}
                />
                <Field
                    name={'newPassword'}
                    type={'input'}
                    label={t('New password')}
                    params={{required: true}}
                    property={{
                        type: 'password',
                        placeholder: t('New password'),
                        showPasswordToggle: true,
                        autoComplete: 'new-password',
                    }}
                />
                <Field
                    name={'confirmPassword'}
                    type={'input'}
                    label={t('Confirm password')}
                    params={{required: true}}
                    property={{
                        type: 'password',
                        placeholder: t('Confirm password'),
                        showPasswordToggle: true,
                        autoComplete: 'new-password',
                    }}
                />
            </Form>
        </div>
    );
};

export default PasswordChangeContainer;
